import type { LoggerService } from '@/services/abstract/LoggerService';
import type { MessageHandlerResult } from '@/services/abstract/poc/MessagingService';
import type { HeliaNode } from '@/types/poc/helia';
import type { LibP2pWithServices } from '@/types/poc/libp2p';
import type { MessageHandler, MessagePayload } from '@/types/poc/message';

type FilesUpdatedResultVariant = Extract<MessageHandlerResult, { type: 'files-updated' }>;

export const createFilesUpdatedHandler = (
  loggerService: LoggerService
): MessageHandler<FilesUpdatedResultVariant> => {
  const log = loggerService.createLogger({ namespace: 'six3ro:p2p:handlers:files-updated' });

  return {
    canHandle: (_topic: string, message: MessagePayload): boolean => message.type === 'files-updated',
    process: (
      message: MessagePayload,
      _libp2p: LibP2pWithServices,
      _heliaNode: HeliaNode | null
    ): FilesUpdatedResultVariant => {
      if (message.type !== 'files-updated') {
        throw new Error(`Invalid message type: expected 'files-updated', got '${message.type}'`);
      }

      const { files, sender } = message;
      log.info(`Received files-updated with ${files.length} files from ${sender}`);

      return {
        type: 'files-updated',
        data: {
          sender,
          files: files
            .filter((file) => file.cid.length > 0)
            .map((file) => ({
              cid: file.cid,
              metadata: file.metadata,
              shouldReplicate: false,
              messageTimestamp: message.timestamp,
            })),
        },
      };
    },
  };
};
